package com.shadowings.gero.presentation.screen

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Slider
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.rememberGraphicsLayer
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.UniliteralRepository
import com.shadowings.gero.domain.model.SavedBuilderWord
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.getPlatform
import com.shadowings.gero.presentation.component.FeatureUnavailableDialog
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.LandingUiState
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.util.currentTimeMillis
import com.shadowings.gero.util.rememberImageExporter
import com.shadowings.gero.util.rememberShareManager
import compose.icons.FeatherIcons
import compose.icons.feathericons.Check
import compose.icons.feathericons.Copy
import compose.icons.feathericons.Download
import compose.icons.feathericons.Edit2
import compose.icons.feathericons.Lock
import compose.icons.feathericons.Save
import compose.icons.feathericons.Share2
import compose.icons.feathericons.Sliders
import compose.icons.feathericons.Trash2
import compose.icons.feathericons.X
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.builder_cartouche_label
import gero.composeapp.generated.resources.builder_copy_btn
import gero.composeapp.generated.resources.builder_delete_btn
import gero.composeapp.generated.resources.clear_input_desc
import gero.composeapp.generated.resources.builder_delete_confirm_desc
import gero.composeapp.generated.resources.builder_delete_confirm_title
import gero.composeapp.generated.resources.builder_edit_btn
import gero.composeapp.generated.resources.builder_edit_dialog_title
import gero.composeapp.generated.resources.builder_example_assembly_meaning
import gero.composeapp.generated.resources.builder_example_assembly_title
import gero.composeapp.generated.resources.builder_example_height_meaning
import gero.composeapp.generated.resources.builder_example_height_title
import gero.composeapp.generated.resources.builder_example_juxtapose_meaning
import gero.composeapp.generated.resources.builder_example_juxtapose_title
import gero.composeapp.generated.resources.builder_example_width_meaning
import gero.composeapp.generated.resources.builder_example_width_title
import gero.composeapp.generated.resources.builder_examples_title
import gero.composeapp.generated.resources.builder_export_png_desc
import gero.composeapp.generated.resources.builder_no_saved_words
import gero.composeapp.generated.resources.builder_placeholder
import gero.composeapp.generated.resources.builder_pro_feature_desc
import gero.composeapp.generated.resources.builder_pro_feature_title
import gero.composeapp.generated.resources.builder_pro_unlock_btn
import gero.composeapp.generated.resources.builder_rtl_label
import gero.composeapp.generated.resources.builder_save_btn
import gero.composeapp.generated.resources.builder_save_dialog_title
import gero.composeapp.generated.resources.builder_saved_words_title
import gero.composeapp.generated.resources.builder_share_desc
import gero.composeapp.generated.resources.builder_unrecognized_prefix
import gero.composeapp.generated.resources.builder_word_meaning_label
import gero.composeapp.generated.resources.builder_word_title_label
import gero.composeapp.generated.resources.chiudi_btn
import gero.composeapp.generated.resources.share_builder
import gero.composeapp.generated.resources.share_title
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

@Composable
fun BuilderScreen(
    uiState: LandingUiState,
    textState: TextFieldValue,
    onTextStateChange: (TextFieldValue) -> Unit,
    isRtl: Boolean,
    onIsRtlChange: (Boolean) -> Unit,
    isCartouche: Boolean,
    onIsCartoucheChange: (Boolean) -> Unit,
    symbolSize: Float,
    onSymbolSizeChange: (Float) -> Unit,
    isFullVersionUnlocked: Boolean = false,
    onSaveBuilderWord: (SavedBuilderWord) -> Unit = {},
    onDeleteBuilderWord: (String) -> Unit = {},
    onUpdateBuilderWord: (SavedBuilderWord) -> Unit = {},
    onPurchaseFullVersion: () -> Unit = {},
    modifier: Modifier = Modifier
) {
    val hapticFeedback = LocalHapticFeedback.current
    val coroutineScope = rememberCoroutineScope()
    val graphicsLayer = rememberGraphicsLayer()
    val imageExporter = rememberImageExporter()
    val shareBuilderString = stringResource(Res.string.share_builder)
    val shareTitle = stringResource(Res.string.share_title)
    val shareManager = rememberShareManager()

    val unrecognizedCodes = remember(textState.text) {
        if (textState.text.isBlank()) emptyList()
        else {
            textState.text.split(Regex("[-:*]"))
                .filter { it.isNotBlank() }
                // Strip MdCWord's optional row height/width modifier suffixes (e.g. "A12h3" -> "A12")
                // before validating, otherwise a valid code with a modifier is flagged as unrecognized.
                .filter { code ->
                    val baseCode = code.replace(Regex("(?:[hw]\\d+(?:\\.\\d+)?)+$"), "")
                    UniliteralRepository.resFromGardinerCode(baseCode) == null &&
                        UniliteralRepository.resFromGardinerCode(baseCode.uppercase()) == null
                }
                .distinct()
        }
    }

    val clipboardManager = LocalClipboardManager.current

    var showSaveDialog by remember { mutableStateOf(false) }
    var showProPromptDialog by remember { mutableStateOf(false) }
    var showFeatureUnavailableDialog by remember { mutableStateOf(false) }
    val isWeb = getPlatform().isWeb

    fun requestPurchase() {
        if (isWeb) {
            showFeatureUnavailableDialog = true
        } else {
            onPurchaseFullVersion()
        }
    }

    var showDeleteConfirmDialog by remember { mutableStateOf(false) }
    var wordToDeleteId by remember { mutableStateOf<String?>(null) }

    var editingWordId by remember { mutableStateOf<String?>(null) }
    var dialogMdc by remember { mutableStateOf("") }
    var dialogTitle by remember { mutableStateOf("") }
    var dialogMeaning by remember { mutableStateOf("") }
    var dialogIsRtl by remember { mutableStateOf(false) }
    var dialogIsCartouche by remember { mutableStateOf(true) }

    var previewCopied by remember { mutableStateOf(false) }
    var copiedSavedWordId by remember { mutableStateOf<String?>(null) }
    var copiedExampleMdc by remember { mutableStateOf<String?>(null) }

    Column(
        modifier = modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.background)
            .verticalScroll(rememberScrollState())
            .padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        // 1. Text Input Field at the very top
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            OutlinedTextField(
                value = textState,
                onValueChange = { newValue ->
                    onTextStateChange(newValue.copy(text = normalizeBuilderInput(newValue.text)))
                },
                label = { Text("Manual de Codage") },
                placeholder = { Text(stringResource(Res.string.builder_placeholder)) },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                trailingIcon = {
                    if (textState.text.isNotEmpty()) {
                        IconButton(
                            onClick = {
                                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                onTextStateChange(TextFieldValue(""))
                            },
                            modifier = Modifier.semantics { testTag = "builder_btn_clear_input" }
                        ) {
                            Icon(
                                imageVector = FeatherIcons.X,
                                contentDescription = stringResource(Res.string.clear_input_desc),
                                modifier = Modifier.size(20.dp)
                            )
                        }
                    }
                },
                shape = RoundedCornerShape(12.dp),
                colors = OutlinedTextFieldDefaults.colors(
                    focusedBorderColor = MaterialTheme.colorScheme.primary,
                    unfocusedBorderColor = MaterialTheme.colorScheme.outline
                )
            )

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (unrecognizedCodes.isNotEmpty()) {
                    Text(
                        text = stringResource(
                            Res.string.builder_unrecognized_prefix,
                            unrecognizedCodes.joinToString(", ")
                        ),
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.Bold,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier
                            .padding(start = 8.dp)
                            .weight(1f),
                        textAlign = TextAlign.End
                    )
                }
            }
        }

        // 2. Preview Card Container with soft gradient background
        val gradientBrush = Brush.linearGradient(
            colors = listOf(
                MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.2f),
                MaterialTheme.colorScheme.secondaryContainer.copy(alpha = 0.2f)
            )
        )
        Card(
            modifier = Modifier
                .fillMaxWidth(),
            shape = RoundedCornerShape(16.dp),
            border = BorderStroke(
                1.dp,
                MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.6f)
            ),
            colors = CardDefaults.cardColors(
                containerColor = Color.Transparent
            )
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(gradientBrush)
                    .padding(horizontal = 16.dp, vertical = 12.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                // 1. Action buttons row ABOVE the preview (no dark background)
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(6.dp, Alignment.End),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    // Save button
                    IconButton(
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            val currentText = textState.text.trim()
                            if (currentText.isNotBlank()) {
                                if (isFullVersionUnlocked) {
                                    editingWordId = null
                                    dialogMdc = currentText
                                    dialogTitle = ""
                                    dialogMeaning = ""
                                    dialogIsRtl = isRtl
                                    dialogIsCartouche = isCartouche
                                    showSaveDialog = true
                                } else {
                                    showProPromptDialog = true
                                }
                            }
                        },
                        modifier = Modifier
                            .size(36.dp)
                            .semantics { testTag = "builder_btn_save" },
                        colors = IconButtonDefaults.iconButtonColors(
                            contentColor = MaterialTheme.colorScheme.primary
                        )
                    ) {
                        Icon(
                            imageVector = FeatherIcons.Save,
                            contentDescription = stringResource(Res.string.builder_save_btn),
                            modifier = Modifier.size(20.dp)
                        )
                    }

                    // Copy button
                    IconButton(
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            val currentText = textState.text.trim()
                            if (currentText.isNotBlank()) {
                                clipboardManager.setText(AnnotatedString(currentText))
                                previewCopied = true
                                coroutineScope.launch {
                                    delay(1500)
                                    previewCopied = false
                                }
                            }
                        },
                        modifier = Modifier
                            .size(36.dp)
                            .semantics { testTag = "builder_btn_copy_preview" },
                        colors = IconButtonDefaults.iconButtonColors(
                            contentColor = if (previewCopied) Color(0xFF4CAF50) else MaterialTheme.colorScheme.primary
                        )
                    ) {
                        Icon(
                            imageVector = if (previewCopied) FeatherIcons.Check else FeatherIcons.Copy,
                            contentDescription = stringResource(Res.string.builder_copy_btn),
                            modifier = Modifier.size(20.dp)
                        )
                    }

                    // Export PNG button
                    IconButton(
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            coroutineScope.launch {
                                try {
                                    val bitmap = graphicsLayer.toImageBitmap()
                                    val rawWord = textState.text.trim().ifBlank { "word" }
                                    val filename =
                                        "MdC_${rawWord.replace(Regex("[^a-zA-Z0-9*:-]"), "_")}"
                                    imageExporter(bitmap, filename)
                                } catch (e: Exception) {
                                    e.printStackTrace()
                                }
                            }
                        },
                        modifier = Modifier
                            .size(36.dp)
                            .semantics { testTag = "builder_btn_export_png" },
                        colors = IconButtonDefaults.iconButtonColors(
                            contentColor = MaterialTheme.colorScheme.primary
                        )
                    ) {
                        Icon(
                            imageVector = FeatherIcons.Download,
                            contentDescription = stringResource(Res.string.builder_export_png_desc),
                            modifier = Modifier.size(20.dp)
                        )
                    }

                    // Share button — not on web: the JS ShareManager can only copy the
                    // caption text (no native share sheet, no image), which is a degraded/
                    // misleading experience compared to Android/iOS's real share sheet.
                    if (!getPlatform().isWeb) {
                        IconButton(
                            onClick = {
                                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                coroutineScope.launch {
                                    try {
                                        val bitmap = graphicsLayer.toImageBitmap()
                                        val rawWord = textState.text.trim().ifBlank { "A1" }
                                        val shareText =
                                            shareBuilderString.replace("%1" + '$' + "s", rawWord)
                                        shareManager(shareText, bitmap, shareTitle)
                                    } catch (e: Exception) {
                                        e.printStackTrace()
                                    }
                                }
                            },
                            modifier = Modifier
                                .size(36.dp)
                                .semantics { testTag = "builder_btn_share" },
                            colors = IconButtonDefaults.iconButtonColors(
                                contentColor = MaterialTheme.colorScheme.primary
                            )
                        ) {
                            Icon(
                                imageVector = FeatherIcons.Share2,
                                contentDescription = stringResource(Res.string.builder_share_desc),
                                modifier = Modifier.size(20.dp)
                            )
                        }
                    }
                }

                // 2. Hieroglyph Preview Area below the buttons
                val displayWord = textState.text.ifBlank { "A1" }
                val displayAlpha = if (textState.text.isBlank()) 0.35f else 1.0f

                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 120.dp)
                        .graphicsLayer { alpha = displayAlpha },
                    contentAlignment = Alignment.Center
                ) {
                    // Capture only this tightly-sized wrapper (not the full-width row above)
                    // so the exported PNG contains just the glyph, matching Android's crop.
                    Box(
                        modifier = Modifier
                            .wrapContentSize()
                            .drawWithContent {
                                graphicsLayer.record {
                                    this@drawWithContent.drawContent()
                                }
                                drawContent()
                            }
                    ) {
                        MdCWord(
                            word = displayWord,
                            rtl = isRtl,
                            cart = isCartouche,
                            size = symbolSize.dp
                        )
                    }
                }
            }
        }

        // 3. Toggles & Slider Settings Card
        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.4f)
            ),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.4f))
        ) {
            Column(
                modifier = Modifier.padding(12.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                // Size Slider Row
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        modifier = Modifier.weight(1f)
                    ) {
                        Icon(
                            imageVector = FeatherIcons.Sliders,
                            contentDescription = null,
                            tint = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.size(18.dp)
                        )
                        Slider(
                            value = symbolSize,
                            onValueChange = { onSymbolSizeChange(it) },
                            valueRange = 32f..120f,
                            modifier = Modifier.weight(1f)
                        )
                    }
                    Text(
                        text = "${symbolSize.toInt()} dp",
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = Modifier.padding(start = 8.dp)
                    )
                }

                // RTL & Cartouche Chips Row
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    FilterChip(
                        selected = isRtl,
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            onIsRtlChange(!isRtl)
                        },
                        label = { Text(stringResource(Res.string.builder_rtl_label)) },
                        leadingIcon = {
                            if (isRtl) {
                                Icon(
                                    imageVector = FeatherIcons.Check,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                            }
                        },
                        modifier = Modifier.weight(1f)
                    )

                    FilterChip(
                        selected = isCartouche,
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            onIsCartoucheChange(!isCartouche)
                        },
                        label = { Text(stringResource(Res.string.builder_cartouche_label)) },
                        leadingIcon = {
                            if (isCartouche) {
                                Icon(
                                    imageVector = FeatherIcons.Check,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                            }
                        },
                        modifier = Modifier.weight(1f)
                    )
                }
            }
        }

        // Section Separator
        HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))

        // 4. Saved Words Section (PRO feature)
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = stringResource(Res.string.builder_saved_words_title),
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.onBackground
            )

            Surface(
                color = if (isFullVersionUnlocked) MaterialTheme.colorScheme.primaryContainer else MaterialTheme.colorScheme.tertiaryContainer,
                shape = RoundedCornerShape(8.dp)
            ) {
                Row(
                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 3.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(4.dp)
                ) {
                    if (!isFullVersionUnlocked) {
                        Icon(
                            imageVector = FeatherIcons.Lock,
                            contentDescription = null,
                            modifier = Modifier.size(12.dp),
                            tint = MaterialTheme.colorScheme.onTertiaryContainer
                        )
                    }
                    Text(
                        text = "PRO",
                        style = MaterialTheme.typography.labelSmall,
                        fontWeight = FontWeight.Bold,
                        color = if (isFullVersionUnlocked) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.onTertiaryContainer
                    )
                }
            }
        }

        if (!isFullVersionUnlocked) {
            // PRO Promotion Card
            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(12.dp),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f)
                ),
                border = BorderStroke(
                    1.dp,
                    MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f)
                )
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp),
                    verticalArrangement = Arrangement.spacedBy(10.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Icon(
                            imageVector = FeatherIcons.Lock,
                            contentDescription = null,
                            tint = MaterialTheme.colorScheme.primary,
                            modifier = Modifier.size(20.dp)
                        )
                        Text(
                            text = stringResource(Res.string.builder_pro_feature_title),
                            style = MaterialTheme.typography.titleSmall,
                            fontWeight = FontWeight.Bold,
                            color = MaterialTheme.colorScheme.onSurface
                        )
                    }

                    Text(
                        text = stringResource(Res.string.builder_pro_feature_desc),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        textAlign = TextAlign.Center
                    )

                    Button(
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            requestPurchase()
                        },
                        shape = RoundedCornerShape(8.dp),
                        modifier = Modifier.semantics { testTag = "builder_btn_unlock_pro" }
                    ) {
                        Text(stringResource(Res.string.builder_pro_unlock_btn))
                    }
                }
            }
        } else {
            // Saved Words List
            val savedWords = uiState.userData.savedBuilderWords.filterNot { it.deleted }
            if (savedWords.isEmpty()) {
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.2f)
                    ),
                    border = BorderStroke(
                        1.dp,
                        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.3f)
                    )
                ) {
                    Text(
                        text = stringResource(Res.string.builder_no_saved_words),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp)
                    )
                }
            } else {
                savedWords.forEach { savedWord ->
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            onTextStateChange(
                                TextFieldValue(
                                    savedWord.mdc,
                                    TextRange(savedWord.mdc.length)
                                )
                            )
                            onIsRtlChange(savedWord.isRtl)
                            onIsCartoucheChange(savedWord.isCartouche)
                        },
                        shape = RoundedCornerShape(12.dp),
                        colors = CardDefaults.cardColors(
                            containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.3f)
                        ),
                        border = BorderStroke(
                            1.dp,
                            MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.4f)
                        )
                    ) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(12.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(
                                modifier = Modifier.weight(1f),
                                verticalArrangement = Arrangement.spacedBy(4.dp)
                            ) {
                                if (savedWord.title.isNotBlank()) {
                                    Text(
                                        text = savedWord.title,
                                        style = MaterialTheme.typography.titleSmall,
                                        fontWeight = FontWeight.Bold,
                                        color = MaterialTheme.colorScheme.onSurface
                                    )
                                }
                                if (savedWord.meaning.isNotBlank()) {
                                    Text(
                                        text = savedWord.meaning,
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant
                                    )
                                }
                                Text(
                                    text = savedWord.mdc,
                                    style = MaterialTheme.typography.labelSmall,
                                    color = MaterialTheme.colorScheme.primary,
                                    fontWeight = FontWeight.SemiBold
                                )

                                Box(
                                    modifier = Modifier.padding(top = 4.dp)
                                ) {
                                    MdCWord(
                                        word = savedWord.mdc,
                                        rtl = savedWord.isRtl,
                                        cart = savedWord.isCartouche,
                                        size = 32.dp
                                    )
                                }
                            }

                            // Action buttons: Copy, Edit, Delete
                            Row(
                                modifier = Modifier.padding(start = 8.dp),
                                horizontalArrangement = Arrangement.spacedBy(16.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                // Copy
                                val isWordCopied = copiedSavedWordId == savedWord.id
                                IconButton(
                                    onClick = {
                                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                        clipboardManager.setText(AnnotatedString(savedWord.mdc))
                                        copiedSavedWordId = savedWord.id
                                        coroutineScope.launch {
                                            delay(1500)
                                            if (copiedSavedWordId == savedWord.id) {
                                                copiedSavedWordId = null
                                            }
                                        }
                                    },
                                    modifier = Modifier
                                        .size(36.dp)
                                        .background(
                                            color = MaterialTheme.colorScheme.surfaceVariant,
                                            shape = RoundedCornerShape(8.dp)
                                        )
                                        .semantics {
                                            testTag = "builder_btn_copy_saved_${savedWord.id}"
                                        }
                                ) {
                                    Icon(
                                        imageVector = if (isWordCopied) FeatherIcons.Check else FeatherIcons.Copy,
                                        contentDescription = stringResource(Res.string.builder_copy_btn),
                                        modifier = Modifier.size(16.dp),
                                        tint = if (isWordCopied) Color(0xFF4CAF50) else MaterialTheme.colorScheme.primary
                                    )
                                }

                                // Edit
                                IconButton(
                                    onClick = {
                                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                        onTextStateChange(
                                            TextFieldValue(
                                                savedWord.mdc,
                                                TextRange(savedWord.mdc.length)
                                            )
                                        )
                                        onIsRtlChange(savedWord.isRtl)
                                        onIsCartoucheChange(savedWord.isCartouche)
                                        editingWordId = savedWord.id
                                        dialogMdc = savedWord.mdc
                                        dialogTitle = savedWord.title
                                        dialogMeaning = savedWord.meaning
                                        dialogIsRtl = savedWord.isRtl
                                        dialogIsCartouche = savedWord.isCartouche
                                        showSaveDialog = true
                                    },
                                    modifier = Modifier
                                        .size(36.dp)
                                        .background(
                                            color = MaterialTheme.colorScheme.surfaceVariant,
                                            shape = RoundedCornerShape(8.dp)
                                        )
                                        .semantics {
                                            testTag = "builder_btn_edit_saved_${savedWord.id}"
                                        }
                                ) {
                                    Icon(
                                        imageVector = FeatherIcons.Edit2,
                                        contentDescription = stringResource(Res.string.builder_edit_btn),
                                        modifier = Modifier.size(16.dp),
                                        tint = MaterialTheme.colorScheme.secondary
                                    )
                                }

                                // Delete
                                IconButton(
                                    onClick = {
                                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                        wordToDeleteId = savedWord.id
                                        showDeleteConfirmDialog = true
                                    },
                                    modifier = Modifier
                                        .size(36.dp)
                                        .background(
                                            color = MaterialTheme.colorScheme.surfaceVariant,
                                            shape = RoundedCornerShape(8.dp)
                                        )
                                        .semantics {
                                            testTag = "builder_btn_delete_saved_${savedWord.id}"
                                        }
                                ) {
                                    Icon(
                                        imageVector = FeatherIcons.Trash2,
                                        contentDescription = stringResource(Res.string.builder_delete_btn),
                                        modifier = Modifier.size(16.dp),
                                        tint = MaterialTheme.colorScheme.error
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        // Section Separator
        HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))

        // 5. Examples list
        Text(
            text = stringResource(Res.string.builder_examples_title),
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.onBackground
        )

        data class ExampleWord(val mdc: String, val title: String, val meaning: String)

        val examples = listOf(
            ExampleWord(
                mdc = "M17-Y5:N35-G43B-S34",
                title = stringResource(Res.string.builder_example_assembly_title),
                meaning = stringResource(Res.string.builder_example_assembly_meaning)
            ),
            ExampleWord(
                mdc = "A12h3:Z1",
                title = stringResource(Res.string.builder_example_height_title),
                meaning = stringResource(Res.string.builder_example_height_meaning)
            ),
            ExampleWord(
                mdc = "Q3w0.5-G1-G40",
                title = stringResource(Res.string.builder_example_width_title),
                meaning = stringResource(Res.string.builder_example_width_meaning)
            ),
            ExampleWord(
                mdc = "O34h0.5:X1*B1",
                title = stringResource(Res.string.builder_example_juxtapose_title),
                meaning = stringResource(Res.string.builder_example_juxtapose_meaning)
            )
        )

        examples.forEach { example ->
            Card(
                modifier = Modifier.fillMaxWidth(),
                onClick = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onTextStateChange(TextFieldValue(example.mdc, TextRange(example.mdc.length)))
                },
                shape = RoundedCornerShape(12.dp),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.25f)
                ),
                border = BorderStroke(
                    1.dp,
                    MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.4f)
                )
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(12.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        Text(
                            text = example.title,
                            style = MaterialTheme.typography.titleSmall,
                            fontWeight = FontWeight.Bold,
                            color = MaterialTheme.colorScheme.onSurface
                        )
                        Text(
                            text = example.meaning,
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                        Text(
                            text = example.mdc,
                            style = MaterialTheme.typography.labelSmall,
                            color = MaterialTheme.colorScheme.primary,
                            fontWeight = FontWeight.SemiBold
                        )
                    }

                    val isExampleCopied = copiedExampleMdc == example.mdc
                    IconButton(
                        onClick = {
                            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                            clipboardManager.setText(AnnotatedString(example.mdc))
                            copiedExampleMdc = example.mdc
                            coroutineScope.launch {
                                delay(1500)
                                if (copiedExampleMdc == example.mdc) {
                                    copiedExampleMdc = null
                                }
                            }
                        },
                        modifier = Modifier
                            .size(40.dp)
                            .background(
                                color = MaterialTheme.colorScheme.surfaceVariant,
                                shape = RoundedCornerShape(8.dp)
                            )
                            .semantics {
                                testTag = "builder_btn_copy_example_${
                                    example.title.lowercase().replace(" ", "_")
                                }"
                            }
                    ) {
                        Icon(
                            imageVector = if (isExampleCopied) FeatherIcons.Check else FeatherIcons.Copy,
                            contentDescription = stringResource(Res.string.builder_copy_btn),
                            modifier = Modifier.size(18.dp),
                            tint = if (isExampleCopied) Color(0xFF4CAF50) else MaterialTheme.colorScheme.primary
                        )
                    }
                }
            }
        }
    }

    // --- Save / Edit Dialog ---
    if (showSaveDialog) {
        AlertDialog(
            onDismissRequest = { showSaveDialog = false },
            title = {
                Text(
                    text = if (editingWordId != null) {
                        stringResource(Res.string.builder_edit_dialog_title)
                    } else {
                        stringResource(Res.string.builder_save_dialog_title)
                    },
                    fontWeight = FontWeight.Bold
                )
            },
            text = {
                Column(
                    verticalArrangement = Arrangement.spacedBy(10.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(vertical = 4.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        MdCWord(
                            word = dialogMdc.ifBlank { "A1" },
                            rtl = dialogIsRtl,
                            cart = dialogIsCartouche,
                            size = 36.dp
                        )
                    }

                    OutlinedTextField(
                        value = dialogTitle,
                        onValueChange = { dialogTitle = it },
                        label = { Text(stringResource(Res.string.builder_word_title_label)) },
                        singleLine = true,
                        modifier = Modifier
                            .fillMaxWidth()
                            .semantics { testTag = "builder_input_save_title" }
                    )

                    OutlinedTextField(
                        value = dialogMeaning,
                        onValueChange = { dialogMeaning = it },
                        label = { Text(stringResource(Res.string.builder_word_meaning_label)) },
                        singleLine = true,
                        modifier = Modifier
                            .fillMaxWidth()
                            .semantics { testTag = "builder_input_save_meaning" }
                    )
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        val wordId = editingWordId ?: currentTimeMillis().toString()
                        val wordToSave = SavedBuilderWord(
                            id = wordId,
                            mdc = dialogMdc,
                            title = dialogTitle.trim(),
                            meaning = dialogMeaning.trim(),
                            isRtl = dialogIsRtl,
                            isCartouche = dialogIsCartouche,
                            timestamp = currentTimeMillis().toString()
                        )
                        if (editingWordId != null) {
                            onUpdateBuilderWord(wordToSave)
                        } else {
                            onSaveBuilderWord(wordToSave)
                        }
                        showSaveDialog = false
                    },
                    modifier = Modifier.semantics { testTag = "builder_dialog_btn_confirm_save" }
                ) {
                    Text(stringResource(Res.string.builder_save_btn))
                }
            },
            dismissButton = {
                TextButton(onClick = { showSaveDialog = false }) {
                    Text(stringResource(Res.string.chiudi_btn))
                }
            }
        )
    }

    // --- PRO Feature Dialog ---
    if (showProPromptDialog) {
        AlertDialog(
            onDismissRequest = { showProPromptDialog = false },
            icon = {
                Icon(
                    imageVector = FeatherIcons.Lock,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.primary,
                    modifier = Modifier.size(28.dp)
                )
            },
            title = {
                Text(
                    text = stringResource(Res.string.builder_pro_feature_title),
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center
                )
            },
            text = {
                Text(
                    text = stringResource(Res.string.builder_pro_feature_desc),
                    textAlign = TextAlign.Center
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        showProPromptDialog = false
                        requestPurchase()
                    },
                    modifier = Modifier.semantics { testTag = "builder_dialog_btn_buy_pro" }
                ) {
                    Text(stringResource(Res.string.builder_pro_unlock_btn))
                }
            },
            dismissButton = {
                TextButton(onClick = { showProPromptDialog = false }) {
                    Text(stringResource(Res.string.chiudi_btn))
                }
            }
        )
    }

    if (showFeatureUnavailableDialog) {
        FeatureUnavailableDialog(onDismiss = { showFeatureUnavailableDialog = false })
    }

    // --- Delete Confirmation Dialog ---
    if (showDeleteConfirmDialog && wordToDeleteId != null) {
        AlertDialog(
            onDismissRequest = {
                showDeleteConfirmDialog = false
                wordToDeleteId = null
            },
            title = {
                Text(
                    text = stringResource(Res.string.builder_delete_confirm_title),
                    fontWeight = FontWeight.Bold
                )
            },
            text = {
                Text(text = stringResource(Res.string.builder_delete_confirm_desc))
            },
            confirmButton = {
                Button(
                    onClick = {
                        wordToDeleteId?.let { onDeleteBuilderWord(it) }
                        showDeleteConfirmDialog = false
                        wordToDeleteId = null
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error),
                    modifier = Modifier.semantics { testTag = "builder_dialog_btn_confirm_delete" }
                ) {
                    Text(
                        text = stringResource(Res.string.builder_delete_btn),
                        color = MaterialTheme.colorScheme.onError
                    )
                }
            },
            dismissButton = {
                TextButton(onClick = {
                    showDeleteConfirmDialog = false
                    wordToDeleteId = null
                }) {
                    Text(stringResource(Res.string.chiudi_btn))
                }
            }
        )
    }
}

private fun insertTextAtCursor(currentValue: TextFieldValue, textToInsert: String): TextFieldValue {
    val selection = currentValue.selection
    val text = currentValue.text
    val newText = text.substring(0, selection.start) + textToInsert + text.substring(selection.end)
    val newSelectionStart = selection.start + textToInsert.length
    return TextFieldValue(
        text = newText,
        selection = TextRange(newSelectionStart)
    )
}

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
fun BuilderScreenPreview() {
    var textState by remember { mutableStateOf(TextFieldValue("M17-Y5:N35-G43B-S34")) }
    var isRtl by remember { mutableStateOf(false) }
    var isCartouche by remember { mutableStateOf(true) }
    var symbolSize by remember { mutableStateOf(64f) }

    AppTheme {
        Surface {
            BuilderScreen(
                uiState = LandingUiState(
                    userData = UserData(
                        language = "it",
                        savedBuilderWords = listOf(
                            SavedBuilderWord(
                                id = "1",
                                mdc = "M17-Y5:N35-G43B-S34",
                                title = "Tutankhamon",
                                meaning = "Immagine vivente di Amon",
                            )
                        )
                    )
                ),
                textState = textState,
                onTextStateChange = { textState = it },
                isRtl = isRtl,
                onIsRtlChange = { isRtl = it },
                isCartouche = isCartouche,
                onIsCartoucheChange = { isCartouche = it },
                symbolSize = symbolSize,
                onSymbolSizeChange = { symbolSize = it },
                isFullVersionUnlocked = true,
                modifier = Modifier.fillMaxSize()
            )
        }
    }
}

// Gardiner codes are always uppercase, but "h"/"w" may be used as
// lowercase suffixes for MdCWord's row height/width modifiers (e.g. "A12h2:Z1"),
// and "a" is used for Gardiner codes like "Aa1".."Aa32".
// Keep 'h'/'w'/'a' and their uppercase counterparts exactly as entered by the user, while forcing all other characters uppercase.
internal fun normalizeBuilderInput(text: String): String = text.map { c ->
    when (c) {
        'h', 'H', 'w', 'W', 'a', 'A' -> c
        else -> c.uppercaseChar()
    }
}.joinToString("")
